import { Component, Vue } from "vue-property-decorator";
import { CreateElement, VNode } from "vue";
import { Prop } from "vue-property-decorator";
import { Module } from "@/store/enums.ts";

@Component
export default class Card extends Vue {
  @Prop() title!: string;
  @Prop({ default: "10" }) columns!: number;
  @Prop({ default: "default" }) mod!: Module;
  @Prop({ default: null }) titleColor!: string;
  @Prop({ default: null }) titleType!: string;
  @Prop({ default: null }) topButton!: { label: string; callbackfn: any };
  vCardTextStyle: Object =
    this.title === undefined ? { padding: "16px 16px" } : {};

  moduleUI: any = {
    [Module.BALLI]: {
      titleType: "toolbar",
      titleColor: "primary"
    },
    [Module.BALA]: {
      titleType: "toolbar",
      titleColor: "secondary"
    },
    [Module.TTMJ]: {
      titleType: "toolbar",
      titleColor: "warning"
    },
    default: {
      titleType: this.titleType,
      titleColor: this.titleColor
    }
  };

  render(h: CreateElement): VNode {
    return (
      <v-container fluid class="fill-height">
        <v-row justify="center">
          <v-col cols={this.columns}>
            <v-card class="elevation-12">
              <div>{this.$slots.preTitle}</div>
              {this.title ? (
                this.moduleUI[this.mod].titleType === "toolbar" ? (
                  <div>
                    <v-toolbar color={this.moduleUI[this.mod].titleColor}>
                      <v-toolbar-title
                        style={{ color: "white", whiteSpace: "initial" }}
                      >
                        {this.title}
                      </v-toolbar-title>
                      {this.topButton ? (
                        <v-btn
                          onClick={this.topButton.callbackfn}
                          style={{ color: "primary", marginLeft: "auto" }}
                        >
                          {this.topButton.label}
                        </v-btn>
                      ) : (
                        ""
                      )}
                    </v-toolbar>
                  </div>
                ) : (
                  <v-card-title>{this.title}</v-card-title>
                )
              ) : (
                ""
              )}
              <v-card-text
                style={{
                  ...this.vCardTextStyle,
                  color: "black",
                  fontSize: "0.95rem"
                }}
              >
                {this.$slots.mainContent}
              </v-card-text>
              <v-card-actions class="justify-center">
                {this.$slots.actions}
              </v-card-actions>
              <div>{this.$slots.progressBar}</div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    );
  }
}

// note this line is extremely important for tsx files that use jsx render,
// otherwise the compononent will not be rendered properly
const component = Card;
